import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../../constants/api";

interface BlogSummary {
  id: number;
  title: string;
  thumb: string;
  date: string;
}

const LatestPost = () => {
  const [latestPosts, setLatestPosts] = useState<BlogSummary[]>([]);

  useEffect(() => {
   axios.get(`${API_BASE_URL}latest-blogs`)
      .then((res) => setLatestPosts(res.data))
      .catch((err) => console.error('Failed to fetch latest blogs:', err));
     
  }, []);

  return (
    <div className="blog-widget">
      <h4 className="widget-title">Latest Post</h4>
      {latestPosts.map((item) => (
        <div key={item.id} className="rc-post-item">
          <div className="rc-post-thumb">
            <Link to={`/blog-details/${item.id}`}>
              <img src={item.thumb} alt="img" />
            </Link>
          </div>
          <div className="rc-post-content">
            
            <span className="date">
              <i className="flaticon-calendar"></i> 
                {new Date(item.date).toLocaleDateString('en-US', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric'
               })}
            </span>
            <h4 className="title">
              <Link to={`/blog-details/${item.id}`}>{item.title}</Link>
            </h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LatestPost;
